import React from 'react'
import PropTypes from 'prop-types'
import { Edit, SimpleForm } from 'react-admin'
import Introspecter from '@api-platform/admin/lib/Introspecter'
import { ResourceEditToolbar } from '../toolbar/ResourceEditToolbar'

const validateForm = (values) => {
  const format = /^[A-Za-z0-9|_|\-|+]+$/

  const errors = {}

  if (values.chargeBeeId && !format.test(values.chargeBeeId)) {
    errors.chargeBeeId = 'ChargeBeeId is not a valid'
  }

  return errors
}

export const IntrospectedEditGuesser = ({
  fields,
  readableFields,
  writableFields,
  schema,
  schemaAnalyzer,
  children,
  toolbar,
  redirect,
  variant,
  initialValues,

  ...props
}) => {
  return (
    <Edit {...props}>
      <SimpleForm
        variant={variant}
        toolbar={toolbar}
        redirect={redirect}
        validate={validateForm}
        initialValues={initialValues}
      >
        {children}
      </SimpleForm>
    </Edit>
  )
}

export const EditGuesser = (props) => (
  <Introspecter component={IntrospectedEditGuesser} {...props} />
)

EditGuesser.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  resource: PropTypes.string.isRequired,
  variant: PropTypes.string,
}

EditGuesser.defaultProps = {
  toolbar: <ResourceEditToolbar />,
  undoable: false,
  redirect: 'list',
  actions: null,
  variant: 'outlined',
}
